export const enum BackgroundOperationStatus {
    Running = 'Running',
    Finished = 'Finished',
    Cancelled = 'Cancelled',
}

export const enum BackgroundOperationType {
    HistoryDump = 'HistoryDump',
}
